import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import SvgIcon from "@xt/SvgIcon";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  const communityArr = Object.freeze([
    {
      mean: "English",
      href: "https://t.me/XTsupport_EN",
    },
    {
      mean: "South Africa",
      href: "https://t.me/XTCOMAfrica",
    },
    {
      mean: "Русский",
      href: "https://t.me/XT_Russia",
    },
    {
      mean: "Tiếng Việt",
      href: "https://t.me/Vietnam_XT",
    },
    {
      mean: "India",
      href: "https://t.me/XT_INDIA",
    },
    {
      mean: "Español",
      href: "https://t.me/XTCOMSpanish",
    },
    {
      mean: "Indonesia",
      href: "https://t.me/XT_Indonesia",
    },
    {
      mean: "日本語",
      href: "https://t.me/XT_JAPAN",
    },
    {
      mean: "Pakistan",
      href: "https://t.me/XTPakistan",
    },
    {
      mean: "Bangladesh",
      href: "https://t.me/XTBangladesh",
    },
    {
      mean: "Türkçe",
      href: "https://t.me/XT_Turkish",
    },
    {
      mean: "Filipino",
      href: "https://t.me/Filipino_XT",
    },
    {
      mean: "Malaysian",
      href: "https://t.me/XT_Malaysian",
    },
    {
      mean: "· العربية",
      href: "https://t.me/XT_Arabic",
    },
    {
      mean: "Français",
      href: "https://t.me/XTFrench",
    },
    {
      mean: "Deutsch",
      href: "https://t.me/XTGerman",
    },
    {
      mean: "Italiano",
      href: "https://t.me/XTItalian",
    },
    {
      mean: "Português",
      href: "https://t.me/XTPortuguese",
    },
    {
      mean: "繁體中文",
      href: "https://t.me/XT_TCHN",
    },
    {
      mean: "العراق",
      href: "https://t.me/XTIraq",
    },
  ]);

  const focusArr = Object.freeze([
    {
      mean: "Facebook",
      href: "https://www.facebook.com/XT.comexchange/",
      icon: "iconguanyu-1",
    },
    {
      mean: "twitter",
      href: "https://twitter.com/XTexchange",
      icon: "iconguanyu-2",
    },
    {
      mean: "Reddit",
      href: "https://www.reddit.com/r/XTExchange/",
      icon: "iconguanyu-5",
    },
    {
      mean: "Medium",
      href: "https://medium.com/@XT_com",
      icon: "iconguanyu-6",
    },
    {
      mean: "Linkedin",
      href: "https://www.linkedin.com/company/31458740/",
      icon: "iconguanyu-7",
    },
    {
      mean: "telegram",
      href: "#m2",
      icon: "iconguanyu-3",
    },
    {
      mean: "Btok",
      href: "https://0.plus/XTsupport",
      icon: "iconguanyu-4",
    },
    {
      mean: "Instagram",
      href: "https://www.instagram.com/xt.com_exchange/",
      icon: "iconguanyu-8",
    },
  ]);
  // const {isLogin} = store.user;

  return (
    <div className={cx(styles.community, className)} style={{ backgroundImage: `url(${require("@/assets/images/aboutus/banner3.png")})` }}>
      <div className={cx(styles.listCentent, className)}>
        <h3 className={cx(styles.cumTitle, className)}>{t("aboutus.tgAndChannel")}</h3>
        <ul className={cx(styles.communityBox, className)}>
          {communityArr &&
            communityArr.map((item, index) => {
              return (
                <li key={index}>
                  <h4>{item?.mean}</h4>
                  <a href={item.href} target="_blank">
                    {item?.href}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <div className={cx(styles.iconCentent, className)}>
        {focusArr &&
          focusArr.map((item, index) => {
            return (
              <a href={item.href} key={index} target="_blank" rel="noopener">
                <em>
                  <SvgIcon style={{ fontSize: "16px" }} icon={item?.icon} />
                </em>
                <b>{item.mean}</b>
              </a>
            );
          })}
      </div>
    </div>
  );
};

export default observer(Main);
// export default Main;
